export default "__VITE_ASSET__BZJ76bsQ__"